import type { Locale } from '../i18n/locales';

interface StatusPanelProps {
  locale: Locale;
  overallPct?: number;
}

export function StatusPanel({ locale, overallPct = 62 }: StatusPanelProps): JSX.Element {
  return (
    <div className="status-panel" role="status">
      <div className="status-panel__head">
        <span className="status-panel__title">{locale.statusTitle}</span>
        <span className="status-panel__eta">
          <span
            aria-hidden="true"
            style={{
              width: 6,
              height: 6,
              borderRadius: 999,
              background: 'var(--ds-warning)',
              display: 'inline-block',
            }}
          />
          <span>{locale.statusEta}</span>
        </span>
      </div>
      <div className="status-panel__row">
        <span>{locale.statusOverall}</span>
        <span className="pct">{overallPct}%</span>
      </div>
      <div
        className="status-panel__bar"
        role="progressbar"
        aria-valuenow={overallPct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={locale.statusOverall}
      >
        <span style={{ width: `${overallPct}%` }} />
      </div>
    </div>
  );
}
